import PropTypes from 'prop-types';
import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { UtilitySystem } from 'rhinostyle';

import * as UserHelpers from '../helpers/UserHelpers';
import MultiOrgContainer from '../containers/MultiOrgContainer';

const RhinophoneMenu = (props) => {
  const history = useHistory();
  const {
    handleNavigationClick,
    organizations,
    currentUser,
  } = props;

  const menuOptions = [
    {
      title: 'Dashboard',
      id: 'nav-phone-dashboard',
      to: '/phone/dashboard',
      dataCypress: 'phoneDashboardOption',
      isVisible: true,
    },
    {
      title: 'Phone',
      id: 'nav-phone-log',
      to: '/phone/phone-log',
      dataCypress: 'phoneLogOption',
      isVisible: true,
    },
    {
      title: 'First Time Callers',
      id: 'nav-settings-phone-caller',
      to: '/phone/first-time-callers',
      dataCypress: 'firstTimeCallerOption',
      isVisible: true,
    },
    {
      title: 'Fax',
      id: 'nav-settings-phone-fac',
      to: '/phone/fax',
      dataCypress: 'phoneFaxOption',
      isVisible: true,
    },
  ];

  const renderMenuListItems = () =>
    menuOptions
      .filter((option) => option.isVisible)
      .map((option) => (
        <li key={option.id} className="app-navigation__nav__sub">
          <NavLink
            id={option.id}
            to={option.to}
            data-cypress={option.dataCypress}
            onClick={handleNavigationClick}
            className="app-navigation__nav__button"
            activeClassName={UtilitySystem.config.classes.active}
          >
            <span>{option.title}</span>
          </NavLink>
        </li>
      ));

  return (
    <nav id="app-navigation" className="app-navigation">
      <div className="app-navigation__container">
        <div className="app-navigation__top">
          <div className="app-navigation__container__scroll">
            <ul className="app-navigation__nav">
              <li className="app-navigation__nav__header">
                <span className="app-navigation__nav__button__text">Rhinophone</span>
              </li>
              <div className="app-navigation__list-item__divider" />
              {renderMenuListItems()}
            </ul>
          </div>
        </div>
        <div className="app-navigation__bottom">
          {currentUser.organization && (
          <div className="app-navigation__org">
            {organizations[currentUser.organization].name}
            <span>Organization{UserHelpers.isCCR(currentUser) && ` (#${organizations[currentUser.organization].id})`}</span>
          </div>
          )}
          <MultiOrgContainer history={history} />
        </div>
      </div>
    </nav>
  );
};

RhinophoneMenu.propTypes = {
  handleNavigationClick: PropTypes.func,
  organizations: PropTypes.object,
  currentUser: PropTypes.object,
};

export default RhinophoneMenu;
